export default __webpack_public_path__ + "static/media/csv.803293bb.svg";